module.exports = __webpack_public_path__ + "media/images/problems/scienze-8269448f972748254e3ac9aaf802815d.jpg";